import { Tabs as TabsList } from 'cpool-components/general/Tabs';
import type { CUSTOMER_DATA_TAB } from 'cpool-constants';
import { CUSTOMER_DATA_TABS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { NotificationCountBadge } from './shared/NotificationCountBadge.tsx';
import { useCustomerDataTabsContext } from '~/features/leadDetails/context/CustomerDataTabsContext.tsx';

const TAB_ORDER: CUSTOMER_DATA_TAB[] = [
    CUSTOMER_DATA_TABS.PERSONAL_DATA,
    CUSTOMER_DATA_TABS.EMPLOYMENT,
    CUSTOMER_DATA_TABS.LIVING_SITUATION,
    CUSTOMER_DATA_TABS.REAL_ESTATE,
    CUSTOMER_DATA_TABS.INCOME_AND_EXPENSES,
];

export const Tabs = () => {
    const { notifications, setTab, tab: currentTab } = useCustomerDataTabsContext();
    const { t } = useTranslation();

    const tabs = TAB_ORDER.map((tab) => {
        const tabNotifications = notifications[tab];
        return {
            id: tab,
            label: t(`CUSTOMER_DATA_TABS.${tab}`),
            suffix:
                tabNotifications.length > 0 ? <NotificationCountBadge count={tabNotifications.length} /> : undefined,
        };
    });

    const handleSelect = (id: string) => {
        const selectedTab = TAB_ORDER.find((tab) => tab === id);
        if (selectedTab) setTab(selectedTab);
    };

    return (
        <TabsList
            tabs={tabs}
            selectedId={currentTab}
            onSelect={handleSelect}
            className="mb-2"
            listClassName="w-full px-0"
        />
    );
};
